import * as React from 'react';
import { Media as MediaProps } from './model';
import BackgroundImage from 'components/styles/BackgroundImage';
import { MediaBg } from './styles';

const Media = ({
  id,
  type,
  url,
  width = '100%',
  height = '100%'
}: MediaProps) => {
  // console.log('Media url', url);
  return <MediaBg backgroundImages={[url]} width={width} height={height} />
};

export default Media;
